import React from "react";

export default function PatientCard({ patient, onSelect, onEdit, onDelete, selected }) {
  return (
    <div className={`patient-card ${selected ? "selected" : ""}`}>
      <div
        onClick={() => onSelect && onSelect(patient)}
        style={{ cursor: "pointer" }}
      >
        <div className="patient-card-top">
          <div className="patient-avatar">
            {patient.name?.charAt(0) || "P"}
          </div>

          <div className="patient-meta">
            <h3>{patient.name}</h3>
            <p>
              {patient.age ?? "-"} yrs • {patient.gender}
            </p>
          </div>
        </div>

        <div className="patient-card-bottom">
          <span className="pill">
            {patient.relation || "self"}
          </span>

          <span className="pill soft">
            {patient.sessions_count || 0} sessions
          </span>
        </div>
      </div>

      <div
        className="patient-card-bottom"
        style={{ marginTop: 14, justifyContent: "flex-end", gap: 8 }}
      >
        <button
          type="button"
          className="btn btn-secondary"
          onClick={(e) => {
            e.stopPropagation();
            onEdit?.(patient);
          }}
        >
          Edit
        </button>

        <button
          type="button"
          className="btn btn-ghost"
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.(patient);
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
}